import React from 'react'
export const SectionContext = React.createContext()
